function WalletIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="w-6 h-6"
    >
      {/* Wallet body */}
      <path d="M21 12V7H5a2 2 0 0 1 0-4h14v4" />
      <path d="M3 5v14a2 2 0 0 0 2 2h16v-5" />
      {/* Card slot */}
      <path d="M18 12a2 2 0 0 0 0 4h4v-4Z" />
      <circle cx="20" cy="14" r="1" />
    </svg>
  )
}

export default WalletIcon
